enum Action {
  ADD_PAY = 'addPay',
  UPDATE_PAY = 'updatePay',
  UPDATE_TOTAL = 'updateTotal',
  REMOVE_PAY = 'removePay',
  SET_TREE = 'setTree',
}

export default Action;
